import { useContext } from 'react';

import { useUpdateSettingsUserMutation } from '@api/settings';
import { Setting } from '@apiContract';
import { SettingsContext } from '@contexts/SettingsContext';

export const useUpdateSettingsUser = () => {
  const settings = useContext(SettingsContext);
  const [updateSettings, { isLoading }] = useUpdateSettingsUserMutation();

  const updateSettingsUser = async (settingNames: Array<string>, values: Record<string, string | boolean>) => {
    const data = settingNames.reduce<Setting[]>((acc, settingName) => {
      const setting = settings[settingName];
      if (setting) {
        acc.push({ ...setting, userSettingValue: values[settingName].toString() });
      }

      return acc;
    }, []);

    return updateSettings(data).unwrap();
  };

  return { updateSettingsUser, isLoading };
};
